import React from 'react';
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import feature2 from '../assets/truckLocations.png';
import feature3 from '../assets/jobStats.png';
import feature1 from '../assets/driverScore.png';

const MobileFeatures = () => {
  const { scrollYProgress } = useViewportScroll();

  // Map scroll position to translateY for parallax effect with quicker rendering
  const translateY1 = useTransform(scrollYProgress, [0, 0.1], [50, 0]);
  const opacity1 = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  const translateY2 = useTransform(scrollYProgress, [0.1, 0.2], [50, 0]);
  const opacity2 = useTransform(scrollYProgress, [0.1, 0.2], [0, 1]);

  const translateY3 = useTransform(scrollYProgress, [0.2, 0.3], [50, 0]);
  const opacity3 = useTransform(scrollYProgress, [0.2, 0.3], [0, 1]);

  // Button appears much later
  const translateYButton = useTransform(scrollYProgress, [0.4, 0.5], [50, 0]);
  const opacityButton = useTransform(scrollYProgress, [0.4, 0.5], [0, 1]);

  return (
    <section className="bg-gray-100 py-20">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <motion.h2
            className="text-4xl font-bold text-gray-800"
            style={{ translateY: translateY1, opacity: opacity1 }}
          >
            Why Choose HaulRadar?
          </motion.h2>
          <motion.p
            className="text-gray-600 mt-4"
            style={{ translateY: translateY2, opacity: opacity2 }}
          >
            Revolutionize your truck hiring and management with our cutting-edge app.
          </motion.p>
        </div>

        <div className="mt-16 flex flex-wrap justify-center">
          <motion.div
            className="w-full md:w-1/3 px-6 mb-12"
            style={{ translateY: translateY1, opacity: opacity1 }}
          >
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <img
                src={feature1}
                alt="Feature 1"
                className="mx-auto mb-4"
                style={{ width: '90%', height: 'auto' }} // Reduce image size by 10%
              />
              <h3 className="text-2xl font-semibold text-gray-800">Plan Your Hauling Jobs</h3>
              <p className="text-gray-600 mt-4">
                HaulRadar estimates how many trucks your job needs and allows you to assign employees to your equipment or hire trucks from other companies.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="w-full md:w-1/3 px-6 mb-12"
            style={{ translateY: translateY2, opacity: opacity2 }}
          >
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <img
                src={feature2}
                alt="Feature 2"
                className="mx-auto mb-4"
                style={{ width: '90%', height: 'auto' }} // Reduce image size by 10%
              />
              <h3 className="text-2xl font-semibold text-gray-800">Real-Time Tracking</h3>
              <p className="text-gray-600 mt-4">
                Monitor truck locations and job progress in real-time. Stay updated on cycle times and improve your site's productivity.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="w-full md:w-1/3 px-6 mb-12"
            style={{ translateY: translateY3, opacity: opacity3 }}
          >
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <img
                src={feature3}
                alt="Feature 3"
                className="mx-auto mb-4"
                style={{ width: '90%', height: 'auto' }} // Reduce image size by 10%
              />
              <h3 className="text-2xl font-semibold text-gray-800">Live Industry-Specific Stats</h3>
              <p className="text-gray-600 mt-4">
                Generate detailed reports on truck usage, hours, and completed jobs. Make informed decisions and optimize your operations.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="text-center mt-16"
          style={{ translateY: translateYButton, opacity: opacityButton }}
        >
          <a
            href="https://dashboard.haulradar.com/sign-up"
            className="bg-black text-white font-bold py-3 px-6 rounded-full hover:bg-gray-800"
          >
            Get Started Today
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MobileFeatures;
